import React from 'react'
import FixtureAPITemplate from '../../Public/FootballAPI/Fixture/FixtureTemplates/FixtureAPITemplate'
import FixtureTemplate from '../../Public/FootballAPI/Fixture/FixtureTemplates/FixtureTemplate'

function ConditionalFixtureTemplate({fixture, statusFixture, type}) {

    let componentToRender = statusFixture ? <FixtureAPITemplate id={fixture.fixtureId} type={type} /> : fixture.full_fixture ? <FixtureTemplate fixture={fixture.full_fixture} type={type} /> : <FixtureAPITemplate id={fixture.fixtureId}  type={type} />

    return (
        <div>
            {componentToRender}
        </div>
    )
}
export default ConditionalFixtureTemplate